import {ssrSafeLocation} from '@github-ui/ssr-utils'

const SAFE_LINK_PROTOCOLS = new Set(['http:', 'https:', 'mailto:'])
const SAFE_FULL_HREF_PROTOCOLS = new Set(['http:', 'https:'])
const ABSOLUTE_URL_PROTOCOL_PATTERN = /^[a-z][a-z\d+\-.]*:/i

/**
 * Returns the URL if it parses and uses a safe protocol (http/https/mailto),
 * otherwise undefined. Blocks `javascript:` and `data:` URI XSS via user-controlled
 * artifact bodies. Anchor-only (`#…`) values are returned as-is.
 */
export function safeHref(url: string | undefined | null): string | undefined {
  if (!url) return undefined
  if (url.startsWith('#')) return url
  return parseSafeHref(url, SAFE_LINK_PROTOCOLS) ? url : undefined
}

export function isSafeFullHref(url: string): boolean {
  return ABSOLUTE_URL_PROTOCOL_PATTERN.test(url) && parseSafeHref(url, SAFE_FULL_HREF_PROTOCOLS) !== undefined
}

function parseSafeHref(url: string, safeProtocols: Set<string>): URL | undefined {
  try {
    const parsed = new URL(url, ssrSafeLocation.origin)
    return safeProtocols.has(parsed.protocol) ? parsed : undefined
  } catch {
    return undefined
  }
}
